export * from "./location-assignment-modal.component";
